import { buildFlightCardLegRowsFromDeal } from "../../Components/FlightBookingFlowMockup/adapters/flightOfferAdapter";

/**
 * Normalize any LDS / package / card-leg shape into HPM summary leg:
 * { from, to, depart, arrive, airline, airlineCode, flightNo, duration, seatsLeft }
 */
export function normalizeUnifiedFlightLeg(leg, offer = null) {
  if (!leg || typeof leg !== "object") return null;

  const from =
    leg.from ||
    leg.originCode ||
    leg.depIata ||
    leg.origin ||
    "";
  const to =
    leg.to ||
    leg.destinationCode ||
    leg.arrIata ||
    leg.destination ||
    "";
  const depart =
    leg.depart ||
    leg.departureTime ||
    leg.depTime ||
    "";
  const arrive =
    leg.arrive ||
    leg.arrivalTime ||
    leg.arrTime ||
    "";
  const airline =
    leg.airline ||
    leg.airlineName ||
    offer?.airlineSummary ||
    offer?.airline?.name ||
    "";
  const airlineCode =
    leg.airlineCode ||
    offer?.cardMeta?.airlineCode ||
    offer?.airline?.code ||
    "";
  const flightNo =
    leg.flightNo ||
    leg.flightNumber ||
    "";
  const duration =
    leg.duration ||
    leg.durationLabel ||
    "";

  if (!from && !to && !depart && !arrive && !flightNo && !airlineCode) {
    return null;
  }

  return {
    from: String(from || "").trim(),
    to: String(to || "").trim(),
    depart: String(depart || "").trim(),
    arrive: String(arrive || "").trim(),
    airline: String(airline || "").trim(),
    airlineCode: String(airlineCode || "").trim(),
    flightNo: String(flightNo || "").trim(),
    duration: String(duration || "").trim(),
    seatsLeft: leg.seatsLeft,
  };
}

/**
 * Resolve outbound/inbound for summary from a flight option and/or raw LDS deal.
 */
export function resolveUnifiedFlightLegs({
  outbound = null,
  inbound = null,
  legs = null,
  cardLegRows = null,
  rawDeal = null,
  offer = null,
} = {}) {
  let out = normalizeUnifiedFlightLeg(outbound, offer);
  let inn = normalizeUnifiedFlightLeg(inbound, offer);

  if (!out || !inn) {
    const rows = Array.isArray(cardLegRows)
      ? cardLegRows
      : Array.isArray(offer?.cardLegRows)
        ? offer.cardLegRows
        : Array.isArray(legs)
          ? legs
          : [];
    if (!out && rows[0]) out = normalizeUnifiedFlightLeg(rows[0], offer);
    if (!inn && rows[1]) inn = normalizeUnifiedFlightLeg(rows[1], offer);
  }

  if ((!out || !inn) && rawDeal) {
    try {
      const fromDeal = buildFlightCardLegRowsFromDeal(rawDeal);
      if (!out && fromDeal[0]) {
        out = normalizeUnifiedFlightLeg(fromDeal[0], offer);
      }
      if (!inn && fromDeal[1]) {
        inn = normalizeUnifiedFlightLeg(fromDeal[1], offer);
      }
    } catch {
      /* ignore deal parse errors */
    }
  }

  return { outbound: out, inbound: inn };
}
